import React from 'react';
import FeaturedImage from '../FeaturedImage';

function team(props) {
    const { post, postType } = props;

    let featuredImage;
    let role;
    let roleAdditional;

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded.hasOwnProperty('wp:featuredmedia')
    ) {
        featuredImage = (
            <FeaturedImage
                imageSize={'employee-card'}
                image={post._embedded['wp:featuredmedia']}
                srcSet={post.featured_image_srcset}
            ></FeaturedImage>
        );
    } else {
        featuredImage = <span className="team-card__img-placeholder" />;
    }

    if (post.acf.role) {
        role = (
            <span
                className="team-card__role"
                dangerouslySetInnerHTML={{ __html: post.acf.role }}
            />
        );
    }

    if (post.acf.role_additional) {
        roleAdditional = (
            <span
                className="team-card__role"
                dangerouslySetInnerHTML={{ __html: post.acf.role_additional }}
            />
        );
    }

    return (
        <article
            id={`${postType}-${post.id}`}
            className="eight29-post eight29-post-card eight29-post-team team-card"
        >
            <a className="team-card__link" href={post.link}>
                <figure className="team-card__wrapper">
                    <div className="team-card__img">{featuredImage}</div>
                    <figcaption className="team-card__content">
                        <h4
                            className="team-card__name"
                            dangerouslySetInnerHTML={{
                                __html: post.title.rendered,
                            }}
                        />
                        {role}
                        {roleAdditional}
                    </figcaption>
                </figure>
            </a>
        </article>
    );
}

export default team;
